import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';

import { EmptyClassroom } from '@innovamat/glimmer-assets';
import { Typography } from '@innovamat/glimmer-components';

import { useOrganization } from '../../../hooks/use-organization';

import { SchoolClassroomsDropdown } from './school-classrooms-dropdown';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const Text = styled.div`
  text-align: center;
`;

const SubtleText = styled(Typography.Body1)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  max-width: 800px;
`;

function SchoolClassroomsEmptyState(): JSX.Element {
  const { t } = useTranslation();
  const { isRosteringEnabled } = useOrganization();

  return (
    <Container>
      <EmptyClassroom />
      <Text>
        <Typography.H4>
          {t(
            'select-classrooms.select-classroom.empty-state.title',
            'Este centro aún no tiene clases creadas'
          )}
        </Typography.H4>
        <SubtleText>
          {isRosteringEnabled ? (
            <Trans
              i18nKey="rostering.action-disabled.message"
              components={{
                b: <b />,
              }}
            />
          ) : (
            t(
              'select-classrooms.select-classroom.empty-state.description',
              'Crea una nueva clase usando el botón de "añadir clase"'
            )
          )}
        </SubtleText>
      </Text>

      <SchoolClassroomsDropdown />
    </Container>
  );
}

export { SchoolClassroomsEmptyState };
